import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    FilterDeleteInput,
    DeleteFilter as DeleteFilterMutation,
    DeleteFilterVariables as DeleteFilterMutationVariables,
    GetProspectorSavedFilters as GetFiltersQuery,
} from 'nutshell-graphql-types';

import DELETE_FILTER from '../mutations/delete-saved-filter.graphql';
import GET_PROSPECTOR_SAVED_FILTERS from '../queries/get-prospector-saved-filters.graphql';

import {PROSPECTOR_TYPE} from './use-get-prospector-saved-filters';

export function useDeleteFilter(): {
    deleteFilter: (arg1: FilterDeleteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [deleteFilter, {loading, error}] = useMutation<
        DeleteFilterMutation,
        DeleteFilterMutationVariables
    >(DELETE_FILTER);

    return {
        deleteFilter: (input: FilterDeleteInput) =>
            deleteFilter({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const cacheResult: GetFiltersQuery | null | undefined = proxy.readQuery({
                        query: GET_PROSPECTOR_SAVED_FILTERS,
                        variables: {
                            type: PROSPECTOR_TYPE,
                        },
                    });

                    const deletedFilter =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.filterDelete &&
                        mutationResults.data.filterDelete.filter;

                    if (!deletedFilter) return;

                    if (cacheResult) {
                        proxy.writeQuery({
                            query: GET_PROSPECTOR_SAVED_FILTERS,
                            variables: {
                                type: PROSPECTOR_TYPE,
                            },
                            data: {
                                filters: cacheResult.prospectorSavedFilters.filter(
                                    (filter) => filter.id !== deletedFilter.id
                                ),
                            },
                        });
                    }
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
